<template>
  <div class="mains">
      <el-container>
          <el-header height="70px">
              <HeaderComponet></HeaderComponet>
          </el-header>
          <el-container>
              <el-aside width="200px">
                  <AsideComponet></AsideComponet>
              </el-aside>
              <el-main>
                  <keep-alive>
                      <router-view></router-view>
                  </keep-alive>
              </el-main>
          </el-container>
      </el-container>
  </div>
</template>



<script>
import HeaderComponet from '../components/HeaderComponet.vue';
import AsideComponet from '../components/AsideComponet.vue';


export default {
  data() {
      return {
          code:''
      }
  },
  mounted(){
  },
  methods: {
  },
  components: {
      HeaderComponet,
      AsideComponet
  }
}
</script>

<style scoped lang="scss">
  .el-header, .el-footer {
    background-color: #409eff;
    color: #333;
    text-align: center;
    line-height: 60px;
  }
  
  .el-aside {
    // background-color: #ffffff;
    color: #333;
    // text-align: center;
    // line-height: 100px;
    height: calc(100vh - 70px);
    overflow-x: hidden;
  }
  
  .el-main {
    background-color: #E9EEF3;
    height: calc(100vh - 70px);
    color: #333;
    padding: 10px;
  }
  
</style>